export default {
    apiKey: "AIzaSyC9e0WDxEe40w_UhXktYIEYU3yXPXZi7V8",
    authDomain: "entrainment-guitar.firebaseapp.com",
    databaseURL: "https://entrainment-guitar.firebaseio.com",
    projectId: "entrainment-guitar",
    storageBucket: "entrainment-guitar.appspot.com",
    messagingSenderId: "735507209790",
    appId: "1:735507209790:web:083e80aafc535c3056bb6f",
    measurementId: "G-E9CX9E54BN"
}

// const firebaseConfig =